// extracted by mini-css-extract-plugin
export default {"calendar-absences-container":"calendar-absences-container--AtyGC","calendarAbsencesContainer":"calendar-absences-container--AtyGC"};